import { render, staticRenderFns } from "./OwnerIdentification.vue?vue&type=template&id=65ce5087&scoped=true"
import script from "./OwnerIdentification.vue?vue&type=script&lang=js"
export * from "./OwnerIdentification.vue?vue&type=script&lang=js"
import style0 from "./OwnerIdentification.vue?vue&type=style&index=0&id=65ce5087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce5087",
  null
  
)

export default component.exports